export default {
  text: 1,
  attachment: 2,
  joint: 3,
  status: 4,
  system: 5,
  autoTranslate: 6,
};